import { useTranslation } from "react-i18next";
import IPerson from "../../models/people/IPerson";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import IFilter from "./IFilter";
import { FilterDropdown } from "./dropdown/FilterDropdown";
import { ChangeEvent } from "react";

interface IFiltersProps {
    people: IPerson[];
    filter: IFilter;
    onFilterChanged: (key: "searchText" | keyof IPerson, value: string) => void;
}

export const Filters = (props: IFiltersProps) => {
    const { t } = useTranslation();

    return (
        <Row className="mb-3">
            <Col>
                <Row>
                    <Col>
                        <h4>{t("people.table.filters.title")}</h4>
                    </Col>
                </Row>
                <FilterRow {...props} />
            </Col>
        </Row>
    );
};

const FilterRow = (props: IFiltersProps) => {
    const { t } = useTranslation();
    const { people, filter, onFilterChanged } = props;

    const getDistinctSortedValues = (selector: (p: IPerson) => string) => [...new Set(people
        .map(selector)
        .map((value) => value.trim())
        .filter((value) => value.length > 0))]
        .sort((left, right) => left.localeCompare(right));

    const jobTitles = getDistinctSortedValues((person) => person.position);
    const teams = getDistinctSortedValues((person) => person.team);
    const countries = getDistinctSortedValues((person) => person.country);
    const regions = getDistinctSortedValues((person) => person.region);

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => onFilterChanged("searchText", e.target.value);
    const handleJobTitleChange = (value: string) => onFilterChanged("position", value);
    const handleTeamChange = (value: string) => onFilterChanged("team", value);
    const handleCountryChange = (value: string) => onFilterChanged("country", value);
    const handleRegionChange = (value: string) => onFilterChanged("region", value);

    return (
        <Row>
            <Col>
                <Row className="mb-3">
                    <Col>
                        <FloatingLabel label={t("people.table.filters.search")}>
                        <Form.Control
                            size="lg"
                            type="text"
                            value={filter.searchText}
                            onChange={handleSearchChange}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FilterDropdown
                            values={jobTitles}
                            value={filter.position}
                            defaultLabel={t("people.table.filters.position")}
                            onChange={handleJobTitleChange}
                            />
                    </Col>
                    <Col>
                        <FilterDropdown
                            values={teams}
                            value={filter.team}
                            defaultLabel={t("people.table.filters.team")}
                            onChange={handleTeamChange}
                            />
                    </Col>
                    <Col>
                        <FilterDropdown
                            values={countries}
                            value={filter.country}
                            defaultLabel={t("people.table.filters.country")}
                            onChange={handleCountryChange}
                            />
                    </Col>
                    <Col>
                        <FilterDropdown
                            values={regions}
                            value={filter.region}
                            defaultLabel={t("people.table.filters.region")}
                            onChange={handleRegionChange}
                            />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};